export function GeneralEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="116"
        viewBox="0 0 200 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.8388 17.4308C49.2101 19.6739 55.5171 24.4696 59.7598 31.8181"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M35.5609 13.946C29.009 10.9339 23.3958 13.8479 23.3467 19.9304C29.5857 20.9672 34.2113 18.2097 35.5609 13.946Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M35.5604 13.946C36.5972 7.70696 31.8643 3.39426 25.9382 4.33286C26.8768 10.259 30.4656 13.7404 35.5604 13.946Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M130 14H70C62.268 14 56 20.268 56 28V98C56 105.732 62.268 112 70 112H130C137.732 112 144 105.732 144 98V28C144 20.268 137.732 14 130 14Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M96 40C100.418 40 104 36.4183 104 32C104 27.5817 100.418 24 96 24C91.5817 24 88 27.5817 88 32C88 36.4183 91.5817 40 96 40Z"
          stroke="var(--clr-general-primary)"
        />
        <path d="M102 38L110 46" stroke="var(--clr-general-primary)" strokeLinecap="round" />
        <path
          d="M84 60C88 64.6667 92 64.6667 96 60"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 60C108 64.6667 112 64.6667 116 60"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 74C97.3333 78 102.667 78 108 74"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M79 73C80.6569 73 82 71.6569 82 70C82 68.3431 80.6569 67 79 67C77.3431 67 76 68.3431 76 70C76 71.6569 77.3431 73 79 73Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M119 73C120.657 73 122 71.6569 122 70C122 68.3431 120.657 67 119 67C117.343 67 116 68.3431 116 70C116 71.6569 117.343 73 119 73Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.55"
          d="M72 89H128"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
          strokeDasharray="2 8"
        />
        <path
          opacity="0.55"
          d="M72 101H112"
          stroke="var(--clr-general-primary)"
          strokeLinecap="round"
          strokeDasharray="2 8"
        />
        <path
          opacity="0.45"
          d="M174 58L176 63L181 65L176 67L174 72L172 67L167 65L172 63L174 58Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M30.0004 96.5999C31.4363 96.5999 32.6004 95.4358 32.6004 93.9999C32.6004 92.564 31.4363 91.3999 30.0004 91.3999C28.5645 91.3999 27.4004 92.564 27.4004 93.9999C27.4004 95.4358 28.5645 96.5999 30.0004 96.5999Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
